module.exports = __webpack_public_path__ + "assets/img/Yoobic-Landing-Page-+-Website.8a237d79.webp";